<template>
	<!-- 更换房间页面 -->
	<div class="ChangeRoom" @click="close_page">
		<div class="changeRoom_main">
			<div class="information_content">
				<!-- 侧边栏部分 -->
				<div class="sidebar">
					<ul>
						<!-- { activate: tab_sideba == item.houseTypeId } -->
						<li v-for="item in newhouseTypeId" :key="item.id"
							:class="tab_sideba == item.houseTypeId?'activate':''"
							@click="switchoverTabs(item.houseTypeId)">
							{{ item.echoMap.houseTypeId }}[{{ item.num }}]
						</li>

					</ul>
				</div>
				<!-- 侧边栏部分 -->

				<!-- 内容区域 -->
				<div class="order_main">
					<div class="change_main">
						<!-- 卡片区域 -->
						<div class="cartlist">
							<div v-for="el in AsiderHoomtype" :key="el.id" @click="radioCard(el)"
								:class="{ change_cards: true, active: isImg === el.id }">
								<div class="change_Price">
									<span>{{ el.roomNumber }}</span>
									<span>
										{{ el.echoMap.houseTypeId }}
									</span>
								</div>
								<div class="room_price">
									<span>￥{{ el.housePrice }}</span>
								</div>
							</div>
							<!-- 卡片区域 -->
						</div>

						<!-- 图片 -->
					</div>
				</div>
				<!-- 内容区域 -->
			</div>
			<!-- <div class="form_submit">
				<el-form :model="roomcard" :rules="rules" ref="roomcard" :inline="true" label-width="100px"
					class="demo-ruleForms">
					<el-form-item label="酒店标识:" prop="sign">
						<el-input :disabled="true" v-model="roomcard.sign"></el-input>
					</el-form-item>
					<el-form-item label="锁号:" prop="value1">
						<el-input :disabled="true" v-model="roomcard.lockBytes"></el-input>
					</el-form-item>
					<el-form-item label="退房时间:" prop="outtime">
						<el-date-picker
						  v-model="roomcard.outtime"
						  format="yyyy-MM-dd HH:mm"
						  type="datetime"
						  placeholder="选择日期时间"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="是否可开反锁" prop="lLock">
					  <el-radio-group v-model="roomcard.lLock">
					    <el-radio :label="1">可以开反锁</el-radio>
					    <el-radio :label="0">不能开反锁</el-radio>
					  </el-radio-group>
					</el-form-item>
					<el-form-item>
						<el-button @click="submitForm">制卡</el-button>
						<el-button @click="carddata(2)">读卡</el-button>
						<el-button @click="carddata(3)" type="danger">销卡</el-button>
					</el-form-item>
				</el-form>
			</div> -->
			<div class="form_submit">
				<el-form :model="makecardinfo" :rules="rules" ref="roomcard" :inline="true" label-width="100px"
					class="demo-ruleForms">
					<!-- <el-form-item label="扇区号:" prop="sectorNo">
						<el-input :disabled="true" v-model="makecardinfo.sectorNo"></el-input>
					</el-form-item> -->
					<!-- <el-form-item label="酒店类型:" prop="hotelType">
						<el-input :disabled="true" v-model="makecardinfo.hotelType"></el-input>
					</el-form-item> -->
					<!-- <el-form-item label="酒店密码:" prop="hotelPwd">
						<el-input :disabled="true" v-model="makecardinfo.hotelPwd"></el-input>
					</el-form-item> -->
					<!-- <el-form-item label="逻辑卡号:" prop="cardNo">
						<el-input :disabled="true" v-model="makecardinfo.cardNo"></el-input>
					</el-form-item> -->
					<!-- <el-form-item label="卡类型:" prop="cardType">
						<el-input :disabled="true" v-model="makecardinfo.cardType"></el-input>
					</el-form-item> -->
					<el-form-item label="门锁代号:" prop="doorId">
						<el-input :disabled='true' v-model="makecardinfo.doorId"></el-input>
					</el-form-item>
					<!-- <el-form-item label="套房号:" prop="suitDoor">
						<el-input :disabled="true" v-model="makecardinfo.suitDoor"></el-input>
					</el-form-item> -->
					<!-- <el-form-item label="公共门:" prop="pubDoor">
						<el-input :disabled="true" v-model="makecardinfo.pubDoor"></el-input>
					</el-form-item> -->
					<!-- <el-form-item label="宾客流水号:" prop="guestSn">
						<el-input :disabled="true" v-model="makecardinfo.guestSn"></el-input>
					</el-form-item> -->
					<el-form-item label="宾客序号:" prop="guestNo">
						<!-- @change="guestNoChange" -->
						<el-input-number :disabled='true' v-model="makecardinfo.guestNo"  :precision="0" :controls="false"></el-input-number>
					</el-form-item>
					<el-form-item label="是否写入梯控:" prop="useLift">
						<el-radio-group v-model="makecardinfo.useLift">
						  <el-radio :label="0">不使用</el-radio>
						  <el-radio :label="1">使用</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="电梯控制码:" prop="liftData" v-if="makecardinfo.useLift==1">
						<el-input  v-model="makecardinfo.liftData"></el-input>
					</el-form-item>
					<el-form-item label="取电开关:" prop="usePowerSwitch">
						<el-radio-group v-model="makecardinfo.usePowerSwitch">
						  <el-radio :label="0">不使用</el-radio>
						  <el-radio :label="1">使用</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="取电标识:" prop="systemId">
						<el-tooltip content="为空时无标识" placement="top">
							<el-input  v-model="makecardinfo.systemId"></el-input>
						</el-tooltip>
					</el-form-item>
					<el-form-item label="入住时间:" prop="beginTime">
						<el-date-picker
						  v-model="makecardinfo.beginTime"
						  format="yyyy-MM-dd HH:mm:ss"
						  value-format="yyyy-MM-dd HH:mm:ss"
						  type="datetime"
						  placeholder="选择日期时间"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="离店时间:" prop="endTime">
						<el-date-picker
						  v-model="makecardinfo.endTime"
						  format="yyyy-MM-dd HH:mm:ss"
						  value-format="yyyy-MM-dd HH:mm:ss"
						  type="datetime"
						  placeholder="选择日期时间"
						></el-date-picker>
					</el-form-item>
					
					<el-form-item>
						<el-button @click="makecard">制卡</el-button>
						<!-- <el-button @click="readcard">读卡1</el-button> -->
						<el-button @click="readcard1">读卡</el-button>
						<el-button @click="cancelcard" type="danger">销卡</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		
		<el-dialog
		  title="房卡数据"
		  :visible.sync="cardshow"
		  :modal='false'
		  class="card-zindex"
		  center
		  width="20%"
		> 
		<el-form  label-width="100px" class="demo-ruleForm">
		  <el-form-item label="逻辑卡号"  >
			{{newcardinfo.cardNo}}
		  </el-form-item>
		  <el-form-item label="卡类型"  >
			{{newcardinfo.cardType}}
		  </el-form-item>
		  <el-form-item label="门锁代号"  >
			{{newcardinfo.doorId}}
		  </el-form-item>
		  <!-- <el-form-item label="套房号"  >
			{{newcardinfo.suitDoor}}
		  </el-form-item>
		  <el-form-item label="公共门"  >
			{{newcardinfo.pubDoor}}
		  </el-form-item> -->
		  <el-form-item label="宾客流水号"  >
			{{newcardinfo.guestSn}}
		  </el-form-item>
		  <el-form-item label="宾客序号"  >
			{{newcardinfo.guestNo}}
		  </el-form-item>
		  <el-form-item label="有效起始时间"  >
			{{newcardinfo.beginTime}}
		  </el-form-item>
		  <el-form-item label="有效截止时间"  >
			{{newcardinfo.endTime}}
		  </el-form-item>
		</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		RoomStatusList
	} from "_api/conditionOfHouse";
	import {
		EditdataStatistics
	} from "_api/orderFrom";
	import {gethotelinfo} from "_api/index"
	import { getGuestNo } from "_api/housingSystem"
	import roomCard from "./roomCard.vue"
	import axios from "axios";
	export default {
		name: "MakeCard",
		// props: {
		// 	id: {
		// 		type: String,
		// 	},
		// },
		components: {
		  roomCard,
		},
		data() {
			return {
				tab_sideba: 5,
				isImg: 0,
				ruleForm: {
					remark: "",
					roomNumber: "",
					housePrice: "",
					houseTypeId: 0,
					roomId: 0,
					discount: "",
					houseTypeName: null,
				},
				isRoom: null,
				roomFroms: {}, //办理入住传的数据
				tabFrom: [],
				Addnum: 0,
				newhouseTypeId: [],
				AsiderHoomtype: [],
				realHousePrice: 0,
				parentFrom: [],

				rules: {
					housePrice: [{
							required: true,
							message: "请输入实际价格",
							trigger: "blur"
						},
						{
							pattern: /^(([0-9]|([1-9][0-9]{0,9}))((\.[0-9]{1,2})?))$/,
							message: "整数位最多十位，小数为最多为两位，可以无小数位",
							trigger: "blur",
						},
					],
				},

				//制门卡
				roomcard: {
					sign: undefined,
					// sign: 132627,
					cardNo: 0,//卡号
					value1: undefined,
					value2: undefined,
					value3: undefined,
					value4: undefined,
					outtime: undefined, //退房时间
					dai: 0,//客人代
					lLock: 1, //可以开反锁
					cardHexStr: undefined,
					lockBytes:undefined,//锁号
					// lockBytes:'04526175',//锁号
				},
				roomrules: {
					sign: [{
						required: true,
						message: "请先设置酒店标识",
						trigger: "blur"
					}],
					cardNo: [{
							required: true,
							message: "请输入卡号",
							trigger: "blur"
						},
						{
							min: 0,
							max: 15,
							message: "长度在 0 到 15 个字符",
							trigger: "blur",
						},
					],
					outtime: [{
						required: true,
						message: "请输入退房时间",
						trigger: "blur"
					}, ],
					dai: [{
						required: true,
						message: "请输入客人代",
						trigger: "blur"
					}],
				},
				cardshow:false,
				hotelinfo:{},
				checktime:undefined,
				cardinfo:{
					cardTypeName:undefined,
					cardHexStr:undefined,
				},
				
				newroomcard:{
					sectorNo:0,//扇区号
					hotelType:2,//酒店类型
					hotelPwd:undefined,
					useLift:undefined,//0：不使用；1：使用；默认 0
					endAddr:undefined,//电梯结束地址  useLift为1时必填
				},
				newcardinfo:{},//新卡片数据
				makecardinfo:{
					sectorNo:0,
					hotelType:2,
					hotelPwd:'',
					cardNo:'',//为空时自动生成
					cardType:'G',
					doorId:'',//门锁代号
					suitDoor:'0000',//套房号 
					pubDoor:'00000000',
					guestSn:0,//宾客流水号
					guestNo:'',//宾客序号 必传
					useLift:0,//0：不使用；1：使用；默认 0
					liftData:'',//useLift为1时必填
					usePowerSwitch:0,//是否写取电开关
					systemId:'',//取电标识 
					beginTime:'',//入住时间
					endTime:"",//离店时间
				},
				makecardshow:true,
				devastateshow:true,
				brandModel:true,
			};
		},
		created() {
			
		},
		methods: {
			gethotel(){
				console.log('orgid',localStorage.getItem("orgid"))
				gethotelinfo({id:localStorage.getItem("orgid")}).then((res) => {
					console.log('酒店数据',res);
					if(!res.data.data.dlsCoID){
						this.$message({
							message: "请联系品牌负责人设置该酒店房卡标识",
							type: "warning",
						});
						this.$emit('makeclose');//关闭弹窗
					}
					this.hotelinfo={
						...res.data.data
					};
					this.roomcard.sign=res.data.data.dlsCoID;
				});
			},
			createdApi() {
				if (this.Addnum > 1) {
					this.RoomStatusListed();
				}
			},
			// //点击卡片选中对应房型下的房号
			radioCard(el) {
				console.log(el);
				this.roomFroms = el;
				this.isImg = el.id;
				this.ruleForm.roomNumber = el.roomNumber;
				this.ruleForm.housePrice = "￥" + el.housePrice;
				this.realHousePrice = el.housePrice;
				this.ruleForm.houseTypeId = el.houseTypeId;
				this.ruleForm.roomId = el.id;
				this.ruleForm.text = el.remark;
				this.ruleForm.houseTypeName = el.echoMap.houseTypeId;
				this.roomcard.lockBytes=el.lockBytes;
				
				this.makecardinfo.doorId = el.lockBytes;
				getGuestNo({flag:2,key:'BT#'+this.ruleForm.roomId}).then((res) => {
					if(res.data.code==0){
						console.log('宾客',res.data.data);
						this.$set(this.makecardinfo,'guestNo',parseInt(res.data.data));
					}
				})
				if(!el.lockBytes){
					this.$message({
						message: "请设置房间锁号",
						type: "warning",
					});
					return false;
				}
				
			},
			//计算折扣率 real:实际价，rack：门市价
			// getDiscountRate(real, rack) {
			//     return this.ruleFrom.discount = parseInt(real/rack)
			// },
			checkroominfo(houseTypeId,roomId){
				var that=this;
				this.tab_sideba = houseTypeId;
				const params = {
					orgId: localStorage.getItem("orgid"),
					statusList: [],//"1_3"
				};
				RoomStatusList(params).then((res) => {
					if (res.data.code === 0) {
						// res.data.data.forEach((el) => {
						//     el.
						// })
						this.tabFrom.splice(0);
						if(res.data.data){
							res.data.data.forEach(function(value){
								that.tabFrom.push(value);
							});
						}
						// this.tabFrom = res.data.data;
						this.houseTypeSetNumber(this.tabFrom);
						this.switchoverTabs(houseTypeId);
						this.AsiderHoomtype.forEach(function(value){
							if(value.id==roomId){
								that.radioCard(value);
							}
						});
					}
				});
			},

			//房态列表接口
			RoomStatusListed() {
				const params = {
					orgId: localStorage.getItem("orgid"),
					statusList: [],//"1_3"
				};
				var that=this;
				RoomStatusList(params).then((res) => {
					if (res.data.code === 0) {
						this.tabFrom.splice(0);
						if(res.data.data){
							res.data.data.forEach(function(value){
								that.tabFrom.push(value);
							});
						}
						// this.tabFrom = res.data.data;
						this.houseTypeSetNumber(this.tabFrom);
						this.switchoverTabs(this.newhouseTypeId[0].houseTypeId);
					}
				});
			},

			//对房型进行去重和计数
			houseTypeSetNumber(arr) {
				//房型筛选去重
				var that=this;
				var newArr = [];
				var numArr = [];
				var obj = {};
				var uum = 0;
				arr.forEach((i) => {
					newArr.some((item) => item.houseTypeId == i.houseTypeId) ?
						"" :
						newArr.push(i);
				});

				for (let i = 0; i < newArr.length; i++) {
					for (let j = 0; j < arr.length; j++) {
						if (arr[j].houseTypeId === newArr[i].houseTypeId) {
							uum = ++uum;
							(obj.houseTypeId = newArr[i].houseTypeId),
							(obj.echoMap = {
								houseTypeId: arr[j].echoMap.houseTypeId,
							}),
							(obj.num = uum);
						}
					}

					uum = 0;
					numArr.push(obj);
					obj = {};
				}
				this.newhouseTypeId.splice(0);
				numArr.forEach(function(item){
					that.newhouseTypeId.push(item);
				})
				// this.newhouseTypeId = numArr;
			},
			//点击侧边栏切换不同的房型数据
			switchoverTabs(id) {
				console.log('今日',id)
				this.tab_sideba = id;
				this.AsiderHoomtype.splice(0);
				this.tabFrom.forEach((el) => {
					if (el.houseTypeId === id) {
						this.AsiderHoomtype.push(el);
					}
				});
				console.log(this.AsiderHoomtype);
			},
			// 点击右上角的图标隐藏弹窗
			close_page(e) {
				if (e.target.className === "el-icon-close") {
					this.$emit("offChangeRoom", [false, "icon"]);
				}
			},
			//点击提交表单进行验证
			submitForm() {
				
			},
			formattedDate(timestamp) {
			  const date = new Date(timestamp);
			  const year = date.getFullYear();
			  const month = (date.getMonth() + 1).toString().padStart(2, "0");
			  const day = date.getDate().toString().padStart(2, "0");
			  const hour = date.getHours().toString().padStart(2, "0");
			  const minute = date.getMinutes().toString().padStart(2, "0");
			  const second = date.getSeconds().toString().padStart(2, "0");
			  const formattedDate = `${year}${month}${day}${hour}${minute}`;
			  return formattedDate;
			},
			
			lengthCutting(str, num) {
				let strArr = [];
				for (let i = 0; i < str.length; i += num)
					strArr.push(str.slice(i, i + num));
				return strArr;
			},
			
			//读卡
			readcard(){
				var data ={
					sectorNo:0,
					hotelType:this.brandModel?2:1,
					hotelPwd:this.roomcard.sign,//'230814'
				};
				const request = axios.create({
				  baseURL: '/makecard',
				  timeout: 600000,
				  headers: {  
				      'Access-Control-Allow-Origin': '*',  
				  },
				});
				request.post('/readGuestCard', data)  
				  .then((res) => {
				  	console.log("纸卡数据", res);
				  	if(res.data.code == 0){
				  		this.newcardinfo = res.data;
				  		this.$message({
				  			message: "操作成功",
				  			type: "success",
				  		});
				  	}else{
				  		this.$message({
				  			message: res.data.message ||"请重试",
				  			type: "error",
				  		});
				  	}
				}).catch((err)=>{
				  	console.log('错误',err)
				});
			},
			readcard1(){
				var data ={
					sectorNo:0,
					hotelType:this.brandModel?2:1,
					hotelPwd:this.roomcard.sign,//'230814'
				};
				var urlstr='';
				for (let key in data) {
					if(urlstr==''){
						if(data[key]){
							urlstr='?'+key+'='+data[key];
						}else{
							urlstr='?'+key;
						}
					}else{
						if(data[key]){
							urlstr=urlstr+'&'+ key+'='+data[key];
						}else{
							urlstr=urlstr+'&'+key;
						}
					}
				}
				this.$jsonp('http://127.0.0.1:18833/betech/api/readGuestCard'+urlstr).then(res => {
					console.log('res', res)
					const jsonObj = JSON.parse(res);
					console.log('数据',jsonObj)
					if(jsonObj.code == 0){
						this.newcardinfo = jsonObj.data;
						this.$message({
							message: "操作成功",
							type: "success",
						});
						this.cardshow=true;
					}else{
						this.$message({
							message: jsonObj.message ||"请重试",
							type: "error",
						});
					}
					console.log('json数据',jsonObj)
				}).catch(err => {
				               console.log(err)
				});
				return false;
				axios.post('http://127.0.0.1:18833/betech/api/readGuestCard', data)  
				  .then((res) => {
				  	console.log("纸卡数据", res);
				  	if(res.data.code == 0){
				  		this.newcardinfo = res.data;
				  		this.$message({
				  			message: "操作成功",
				  			type: "success",
				  		});
				  	}else{
				  		this.$message({
				  			message: res.data.message ||"请重试",
				  			type: "error",
				  		});
				  	}
				}).catch((err)=>{
				  	console.log('错误',err)
				});
			},
			//制门卡
			makecard(){
				var that =this;
				if(!this.makecardinfo.guestNo){
					this.$message({
						message: "请填写宾客序号",
						type: "warning",
					});
					return false;
				}
				if(!this.makecardinfo.beginTime){
					this.$message({
						message: "请选择入住时间",
						type: "warning",
					});
					return false;
				}
				if(!this.makecardinfo.endTime){
					this.$message({
						message: "请选择离店时间",
						type: "warning",
					});
					return false;
				}
				if(this.makecardinfo.useLift==1){
					if(!this.makecardinfo.liftData){
						this.$message({
							message: "请填写取电开关",
							type: "warning",
						});
						return false;
					}
				}
				var data ={
					sectorNo:this.makecardinfo.sectorNo,
					hotelType:this.brandModel?2:1,
					hotelPwd:this.roomcard.sign,//'230814'
					cardNo:this.makecardinfo.cardNo,//为空时自动生成
					cardType:this.makecardinfo.cardType,
					doorId:this.makecardinfo.doorId,//门锁代号
					suitDoor:this.makecardinfo.suitDoor,//套房号 
					pubDoor:this.makecardinfo.pubDoor,
					guestSn:this.makecardinfo.guestSn,//宾客流水号
					guestNo:this.makecardinfo.guestNo,//宾客序号 必传
					useLift:this.makecardinfo.useLift,//0：不使用；1：使用；默认 0
					liftData:this.makecardinfo.liftData,//useLift为1时必填
					usePowerSwitch:this.makecardinfo.usePowerSwitch,//是否写取电开关
					systemId:this.makecardinfo.systemId,//取电标识 
					beginTime:this.makecardinfo.beginTime,//入住时间
					endTime:this.makecardinfo.endTime,//离店时间
				};
				console.log('提交数据',data);
				var urlstr ='';
				for (let key in data) {
					if(urlstr==''){
						if(data[key]){
							urlstr='?'+key+'='+data[key];
						}else{
							urlstr='?'+key;
						}
					}else{
						if(data[key]){
							urlstr=urlstr+'&'+ key+'='+data[key];
						}else{
							urlstr=urlstr+'&'+key;
						}
					}
				}
				
				this.$jsonp('http://127.0.0.1:18833/betech/api/writeGuestCard'+urlstr, {  
				  timeout:60000, // 设置超时时间为5秒
				  output: 'jsonp',
				}).then(res => {
					console.log('res', res)
					res = JSON.parse(res);
					console.log("纸卡数据", res);
					this.makecardshow=true;
					if(res.code == 0){
						getGuestNo({flag:1,key:'BT#'+that.ruleForm.roomId}).then((resdata) => {
							if(resdata.data.code==0){
								console.log('宾客',resdata.data.data);
								that.$set(that.makecardinfo,'guestNo',parseInt(resdata.data.data));
							}
						});
						this.$message({
							message: "操作成功",
							type: "success",
						});
					}else{
						this.$message({
							message: res.message ||"请重试",
							type: "error",
						});
					}
				}).catch(err => {
					console.log(err)
				});
				// return false;
				// const request = axios.create({
				//   baseURL: '/makecard',
				//   timeout: 600000,
				//   headers: {  
				//       'Access-Control-Allow-Origin': '*',  
				//   },
				// });
				// if(!this.makecardshow){
				// 	this.$message({
				// 		message: "请勿重复点击",
				// 		type: "warning",
				// 	});
				// 	return false;
				// }
				// this.makecardshow=false;
				// request.post('/writeGuestCard', data)  
				//   .then((res) => {
				//   	console.log("纸卡数据", res);
				// 	this.makecardshow=true;
				//   	if(res.data.code == 0){
				// 		getGuestNo({flag:1,key:'BT#'+that.ruleForm.roomId}).then((resdata) => {
				// 			if(resdata.data.code==0){
				// 				console.log('宾客',resdata.data.data);
				// 				that.$set(that.makecardinfo,'guestNo',parseInt(resdata.data.data));
				// 			}
				// 		});
				//   		this.$message({
				//   			message: "操作成功",
				//   			type: "success",
				//   		});
				//   	}else{
				//   		this.$message({
				//   			message: res.data.message ||"请重试",
				//   			type: "error",
				//   		});
				//   	}
				// }).catch((err)=>{
				//   	console.log('错误',err)
				// });
			},
			//销卡
			cancelcard(){
				var data={
					sectorNo:0,
					hotelType:this.brandModel?2:1,
					hotelPwd:this.roomcard.sign,
					useLift:1,//为空时自动生成
					usePowerSwitch:1,
				};
				var urlstr='';
				for (let key in data) {
					if(urlstr==''){
						if(data[key]){
							urlstr='?'+key+'='+data[key];
						}else{
							urlstr='?'+key;
						}
					}else{
						if(data[key]){
							urlstr=urlstr+'&'+ key+'='+data[key];
						}else{
							urlstr=urlstr+'&'+key;
						}
					}
				}
				this.$jsonp('http://127.0.0.1:18833/betech/api/disableGuestCard'+urlstr).then(res => {
					console.log('res', res)
					res = JSON.parse(res);
					console.log("纸卡数据", res);
					this.devastateshow = true;
					if(res.code == 0){
						
						this.$message({
							message: "操作成功",
							type: "success",
						});
					}else{
						this.$message({
							message:res.message || "请重试",
							type: "error",
						});
					}
				}).catch(err => {
					console.log(err)
					this.$message({
						message: "请重试",
						type: "warning",
					});
				});
				return false;
				// const request = axios.create({
				//   baseURL: '/makecard',
				//   timeout: 600000,
				//   headers: {  
				//       'Access-Control-Allow-Origin': '*',  
				//   },
				// });
				// if(!this.devastateshow){
				// 	this.$message({
				// 		message: "请勿重复点击",
				// 		type: "warning",
				// 	});
				// 	return false;
				// }
				// this.devastateshow = false;
				// request.post('/disableGuestCard', data)  
				//   .then((res) => {
				//   	console.log("纸卡数据", res);
				// 	this.devastateshow = true;
				//   	if(res.data.code == 0){
						
				//   		this.$message({
				//   			message: "操作成功",
				//   			type: "success",
				//   		});
				//   	}else{
				//   		this.$message({
				//   			message:res.data.message || "请重试",
				//   			type: "error",
				//   		});
				//   	}
				// }).catch((err)=>{
				//   	console.log('错误',err)
				// 	this.$message({
				// 		message: "请重试",
				// 		type: "warning",
				// 	});
				// });
			},
			//读取电卡
			readcablecard(){
				var data={
					sectorNo:0,
					cardPwd:this.roomcard.sign,//卡密码
				};
				axios({
					method: "POST",
					url: "http://127.0.0.1:18833/betech/api/readGuestPowerSwitch",
					headers: {
						// 'Sec-Fetch-Site': 'same-origin',
						"Access-Control-Allow-Origin": "*",
					},
					data: data,
				}).then((res) => {
					console.log("纸卡数据", res);
					if(res.data.code == 0){
						// this.newcardinfo = res,data;
						this.$message({
							message: "操作成功",
							type: "success",
						});
					}else{
						this.$message({
							message: "请重试",
							type: "warning",
						});
					}
				});
			},
			//制作电卡
			makecablecard(){
				var data={
					sectorNo:0,
					cardPwd:'',
					cardNo:this.roomcard.sign,//为空时自动生成
					cardType:'G',//默认 G
					doorId:'',//门锁代号
					systemId:'',//取电标识  为空时无标识
					
					beginTime:'',
					endTime:'',
				};
				axios({
					method: "POST",
					url: "http://127.0.0.1:18833/betech/api/writeGuestPowerSwitch",
					headers: {
						// 'Sec-Fetch-Site': 'same-origin',
						"Access-Control-Allow-Origin": "*",
					},
					data: data,
				}).then((res) => {
					console.log("纸卡数据", res);
					if(res.data.code == 0){
						// this.newcardinfo = res,data;
						this.$message({
							message: "操作成功",
							type: "success",
						});
					}else{
						this.$message({
							message: "请重试",
							type: "warning",
						});
					}
				});
			},
			//读序列号
			readsequence(){
				axios({
					method: "POST",
					url: "http://127.0.0.1:18833/betech/api/readCardSnr",
					headers: {
						// 'Sec-Fetch-Site': 'same-origin',
						"Access-Control-Allow-Origin": "*",
					},
					data: {},
				}).then((res) => {
					console.log("纸卡数据", res);
					if(res.data.code == 0){
						// this.newcardinfo = res,data;
						this.$message({
							message: "操作成功",
							type: "success",
						});
					}else{
						this.$message({
							message: "请重试",
							type: "warning",
						});
					}
				});
			},
			//宾客序号修改
			guestNoChange(){
				var that = this;
				setTimeout(function(){
				    //1秒后执行刷新
				   if(that.makecardinfo.guestNo<0){
						that.makecardinfo.guestNo = -that.makecardinfo.guestNo;
						console.log('记录',that.makecardinfo.guestNo);
					}
				}, 500); //单位是毫秒
			},
			
		},
	};
</script>

<style lang="scss" scoped>
	.ChangeRoom {
		width: 100%;
		height: 600px;
		background-color: #fff;

		.changeRoom_main {
			width: 100%;
			height: 199px;
			// background: linear-gradient(177deg, #E8FDFE 0%, #FFFFFF 100%);
			border-radius: 5px;

			// 标题部分css
			.order_title {
				display: flex;
				justify-content: space-between;
				align-items: center;
				width: 100%;
				height: 40px;

				.title_icon {
					width: 40px;
					height: 40px;
					text-align: center;
					line-height: 50px;
				}

				p {
					color: black;
					flex: 1;
					text-align: left;
					padding-left: 20px;
					box-sizing: border-box;
				}
			}

			.information_content {
				display: flex;
				width: 100%;
				padding-right: 20px;
				padding-top: 20px;
				box-sizing: border-box;

				// 侧边栏css
				.sidebar {
					width: 150px;
					height: 300px;
					overflow-y: auto;
					ul {
						width: 100%;
						height: 100%;
						display: flex;
						flex-direction: column;
						align-items: center;

						li {
							width: 140px;
							height: 35px;
							border-radius: 8px;
							line-height: 35px;
							background-color: #eefefe;
							color: #5cb5b8;
							text-align: center;
							font-size: 14px;
							margin-bottom: 15px;
						}

						li.activate {
							background-color: #5cb5b8;
							color: #fff;
						}
					}
				}

				.order_main {
					flex: 1;

					.change_main {
						width: 100%;
						height: 400px;
						display: flex;
						flex-direction: column;
						justify-content: space-between;

						.cartlist {
							width: 100%;
							height: 400px;
							padding-left: 10px;
							box-sizing: border-box;
							overflow-y: auto;

							//卡片部分css
							.change_cards {
								width: 180px;
								height: 100px;
								color: #999999;
								display: flex;
								float: left;
								font-size: 15px;
								margin-right: 10px;
								margin-bottom: 10px;
								border-radius: 4px;
								background-color: #f3f3f3;

								.change_Price {
									width: 50%;
									display: flex;
									flex-direction: column;
									padding-left: 10px;
									box-sizing: border-box;
									justify-content: space-around;
								}

								.room_price {
									flex: 1;
									padding: 20px 10px 0 0;
									box-sizing: border-box;
									text-align: right;

									img {
										display: none;
									}
								}
							}
						}

						.change_cards.active {
							background-color: #d7f5f5;
							color: #5cb5b8;

							.room_price {
								// flex: 1;
								// display: flex;
								// flex-direction: column;
								// justify-content: space-between;
								// padding: 10px 10px 0 0;
								// box-sizing: border-box;
								// text-align: right;
								// position: relative;

								// img {
								//   display: block;
								//   position: absolute;
								//   bottom: 15px;
								//   right: 15px;
								// }
							}
						}

						img {
							width: 20px;
							height: 20px;
						}

						.demo_Form {
							text-align: right;
							padding-bottom: 10px;
							padding-right: 32px;
							margin-top: 20px;
							box-sizing: border-box;

							.el-form-item {}
						}
					}
				}
			}

			//最后确认房间号和价格，在提交区域css
			.form_submit {
				width: 100%;
				height: 70px;

				.demo-ruleForms {
					width: 100%;
					height: 70px;
					padding-top: 10px;
					text-align: right;
					box-sizing: border-box;
					padding-right: 10px;

					.el-form-item {
						margin-right: 30px;

						.el-button {
							width: 100px;
							height: 40px;
							border-radius: 6px;
							background-color: #5cb5b8;
							color: #fff;
						}

						.el-form-item:last-child {
							margin-right: 0px;
							margin-left: 20px;
						}
					}

					::v-deep .el-input__inner {
						font-size: 14px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						// 设置输入字体的颜色
						color: #db1212;
					}
				}
			}
		}
	}
	.card-zindex{
		z-index: 222;
	}
</style>